export default {
  productQuantity: [],
  products: {},
  mallType: "2",
  productFrom: "hq",
};
